const footerNav = [
  { id: 0, title: 'About Us', url: '#' },
  { id: 1, title: 'Our Story', url: '#' },
  { id: 2, title: 'Projects', url: '#' },
  { id: 3, title: 'Terms of Use', url: '#' },
  { id: 4, title: 'Privacy Policy', url: '#' }
];

export const helps = [
  { id: 1, title: 'Support', url: '#' },
  { id: 2, title: 'Get Started', url: '#' },
  { id: 3, title: 'Terms of Use', url: '#' },
  { id: 4, title: 'Privacy Policy', url: '#' }
];

export const learnMore = [
  { id: 1, title: 'About Us', url: '#' },
  { id: 2, title: 'Our Story', url: '#' },
  { id: 3, title: 'Projects', url: '#' },
  { id: 4, title: 'Pricing', url: '#' },
  { id: 5, title: 'Features', url: '#' }
];

export const tags = [
  { id: 1, title: 'Still Life', url: '#' },
  { id: 2, title: 'Urban', url: '#' },
  { id: 3, title: 'Nature', url: '#' },
  { id: 4, title: 'Landscape', url: '#' }
];

export const categories = [
  { id: 1, post: 21, title: 'Lifestyle', url: '#' },
  { id: 2, post: 19, title: 'Photography', url: '#' },
  { id: 3, post: 16, title: 'Journal', url: '#' }
];

export default footerNav;
